
import _ from 'lodash'
import LightCarousel from '@/components/lightCarousel.vue'

export default {
  name: "GridItem",
  components: {
    LightCarousel
  },
  props: { salle: { type: Object, default: () => {} }, index :  {type : Number, default: () => {}} },
  data() {
    return {
      isFavorite: false,
      onHover: false,
      sallesFavorites: null,
      sliderOptions: {
        loop: true,
        currentPage: 0
      }
    }
  },
  mounted() {
    this.checkIfFavorite()
  },
  computed: {
    images() {
      return _.orderBy(this.salle.documents, 'order')
    },
    surface(){
      /*if(this.$i18n.locale === "en"){
        return `${Math.round(10.76391041671 * this.salle.superficie)}ft²`
      }*/
      return `${this.salle.superficie}m²`
    }
  },
  methods: {
    toggleFavorite() {
      if (
        this.$store.state.salles.favorites.find(
          (el) => el._id === this.salle._id
        )
      ) {
        this.$emit('removeFavorite')
        this.isFavorite = false
      } else {
        this.$emit('addFavorite')
        this.isFavorite = true
      }
    },
    checkIfFavorite() {
      this.isFavorite = !!this.$store.state.salles.favorites.find(
        (el) => el._id === this.salle._id
      )
    }
  }
}
